import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useBlocker } from "react-router-dom";
import LeftSection from "../Left-Section/Left_section";
import RightSection from "../Right-Section/Right_section";
import { getResult, saveResult, getPDFData } from "../../Apis/endpoints";
import { useParams } from "react-router-dom";
import Resultpopup from "./Resultpopup";

const Result = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [resultData, setResultData] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [nextPath, setNextPath] = useState(null);
  const [pdfstatus, setPdfStatus] = useState(false)
  //  const videoId = "ee81c4be8a0e4408b1432a4fd208d93d"; 
  const { videoId, mode } = useParams(); // Retrieve videoId & mode from the URL

  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (videoId) {
      getResult(videoId).then((data) => setResultData(data));
    }
  }, [videoId]);



  useEffect(() => {
    const fetchResult = async () => {
      if (videoId) { // Ensure videoId exists before fetching
        try {
          const data = await getResult(videoId);
          if (data) {
            setResultData(data);
            setIsSaved(data.is_saved || false);
            setPdfStatus(data.has_error);
          }
        } catch (error) {
          console.error("Error fetching result data:", error);
          // Optionally handle error state for UI, e.g., display an error message
        }
      }
    };

    fetchResult();
  }, [videoId]);


  const handleClick = () => {
    getPDFData(videoId, setIsDownloading);
  };

  console.log(pdfstatus, 'pdf status ')

  const handleSaveVideo = async () => {
    try {
      await saveResult(videoId);
      alert("Results saved successfully!");
      setIsSaved(true);
      setShowPopup(false);
    } catch (error) {
      alert("Error saving results. Please try again.");
    }
  };

  const handleConfirmLeave = () => {
    setShowPopup(false);
    if (nextPath) {
      navigate(nextPath);
    }
  };


  const handleStay = () => {
    setShowPopup(false); // Close popup without navigating
  };

  // console.log(resultData.has_error, "result");

  const leftSectionData = resultData
    ? {
      communication_score: resultData.Communication_Score,
      Path: resultData.s3_path,
      eye_blink_rate: resultData.video_analysis.Eye_Blink_Rate_per_Min,
      // window: resultData.video_analysis.window,
      feedback: resultData.video_analysis.feedback,
      transcript: resultData.text_analysis.transcription,
      v_dp: resultData.audio_analysis.V_DP,
      p_dp: resultData.audio_analysis.P_DP,
      feedback: resultData.merged_feedback
    }
    : null;


  const rightSectionData = resultData
    ? (mode === 'audio' ? { // If mode is 'audio', RightSection needs audio_analysis and text_analysis
        audio_analysis: {
          filler_words: resultData.text_analysis?.filler_words,
          V_DP: resultData.audio_analysis?.V_DP,
          P_DP: resultData.audio_analysis?.P_DP,
          Pace_Sec: resultData.audio_analysis?.Pace_decision,
          Audio_Volume: resultData.audio_analysis?.Audio_Volume,
          Audio_Duration: resultData.audio_analysis?.Audio_Duration,
          Pause_Percentage: resultData.audio_analysis?.Pause_Percentage,
          Pace: resultData.audio_analysis?.Pace,
          transcript: resultData.text_analysis?.transcription,
          Pitch_Modulation: resultData.audio_analysis?.Pitch_Modulation,
          Pause_Distribution: resultData.audio_analysis?.Pause_Distribution,
          Sound_Plot: resultData.audio_analysis.Sound_Plot,
          Tone_Modulation_Array: resultData.audio_analysis?.Tone_Modulation_Array,
          Tone_Modulation:resultData.audio_analysis.Tone_Modulation,
          Tone_Modulation_Score: resultData.audio_analysis.Tone_Modulation_Score,
          error: resultData.audio_analysis?.Error
        },
        text_analysis: resultData.text_analysis // full object
      } : { // For other modes (video, hybrid), RightSection needs video, audio, and text analysis
        video_analysis: resultData.video_analysis,
        audio_analysis: resultData.audio_analysis,
        text_analysis: resultData.text_analysis // Keep text_analysis for other modes too
      })

    : null;

  console.log(resultData, "checking data has error")

  const isAnalysisComplete =
    resultData &&
    resultData.video_analysis &&
    Object.keys(resultData.video_analysis).length > 0 &&
    resultData.audio_analysis &&
    Object.keys(resultData.audio_analysis).length > 0;

  return (
    <div className="flex-1 flex flex-col">
      {/* Header Section */}
      <div className="flex items-center justify-between p-3 sm:p-4 bg-white">
        {/* Assessment Title */}
        <p className="text-xl sm:text-2xl font-semibold font-sans text-[#002952] ps-2">
          Assessment
        </p>
        {/* Action Buttons (Retake, Download PDF) */}
        <div className="flex items-center space-x-1">
          {/* Retake Button/Link */}
          <a
            href="/upload"
            className="text-[#2563EB]
            font-medium
            text-xs
            sm:text-sm
            md:text-base
            lg:text-lg
            px-1 py-1 sm:px-4 sm:py-2 rounded-lg focus:outline-none"
          >
            Retake
          </a>
          {/* Download PDF Button */}
          {!pdfstatus && mode !== 'audio' && isAnalysisComplete && (
            <button
              className={`
        text-xs
        sm:text-sm
        md:text-base
        lg:text-lg
        px-3 py-1 sm:px-4 sm:py-2 rounded-lg focus:outline-none
        ${isDownloading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-[#2563EB] text-white hover:bg-[#1E4FC7]'
                }
      `}
              onClick={handleClick}
              disabled={isDownloading}
            >
              {isDownloading ? 'Downloading...' : 'Download PDF'}
            </button>
          )}
        </div>

      </div>

      {/* Main Content Sections (Left and Right) */}
      <div className="flex flex-1 flex-col lg:flex-row">
        {/* Left Section */}
        <div className="lg:w-[55%] w-full bg-white">
          {/* Assuming LeftSection handles its own internal responsiveness */}
          <LeftSection resultData={leftSectionData} mode={mode} />
        </div>
        {/* Right Section */}
        <div className="lg:w-[45%] w-full bg-white p-3 sm:p-4">
          {/* Assuming RightSection handles its own internal responsiveness */}
          <RightSection resultData={rightSectionData} mode={mode} />
        </div>
      </div>

      {/* Result Popup */}
      {showPopup && (
        <Resultpopup onSave={handleSaveVideo} onLeave={handleConfirmLeave} />
      )}
    </div>
  );
};

export default Result;